import config from '@epi-config';
import { post } from '@epi-helpers/FetchHelpers';

const url = `${config.apiHost}/api/einvoice`;

export function validateEInvoiceRequest(
  payload: any
): Promise<{ valid: boolean }> {
  return post(`${url}/validate`, payload);
}
